import React, { ReactNode, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AppNav from './AppNav';

function AppPage(props: Props) {
  const { pageClass, children } = props;

  useEffect(()  => {
    if (pageClass) {
      document.body.classList.add(pageClass);
      return () => document.body.classList.remove(pageClass);
    }
  }, [pageClass]);

  return (
    <>
      <header>
        <AppNav />
      </header>
      <Container as="main" className="my-4">
        {children}
      </Container>
    </>
  );
}

type Props = {
  pageClass: string;
  children: ReactNode;
};

export default AppPage;